import React from 'react';
import { Box, Flex, Switch } from '@applyboard/crystal-ui';

interface AppAccessSwitchProps {
  appName: string;
  appLabel: string;
  logoSrc: string;
  isDisabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Field: React.ComponentType<any>;
  value?: boolean;
  gap?: 4 | 8;
  showBorder?: boolean;
}

export function AppAccessSwitch({
  appName,
  appLabel,
  logoSrc,
  isDisabled,
  Field,
  value,
  gap = 8,
  showBorder = false,
}: AppAccessSwitchProps): JSX.Element {
  const flexGap = showBorder ? 4 : gap;

  return (
    <Flex
      justify="start"
      align="center"
      grow={1}
      gap={flexGap}
      basis="100%"
      pt={showBorder ? undefined : { xs: 4, sm: 6 }}
    >
      <Box>
        <img alt={`${appLabel} Logo`} src={logoSrc} width={56} height={56} />
      </Box>
      <Flex.Item basis="100%">
        <Field
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          as={Switch}
          label={appLabel}
          name={appName}
          labelPlacement="left"
          width="fill"
          disabled={isDisabled}
          {...(value !== undefined && { value })}
        />
      </Flex.Item>
    </Flex>
  );
}
